import { Component, inject, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";

import { I18nService } from "@bitwarden/common/abstractions/i18n.service";
import { PlatformUtilsService } from "@bitwarden/common/abstractions/platformUtils.service";
import { GlossScrollDirective } from "@bitwarden/web-vault/app/components/gloss-scroll/gloss-scroll.directive";

export type AutoRedemptionTestStateJsonDialogData = {
  json: string;
};

@Component({
  selector: "app-auto-redemption-test-state-json-dialog",
  standalone: true,
  imports: [GlossScrollDirective, MatDialogModule, MatButtonModule],
  templateUrl: "./auto-redemption-test-state-json-dialog.component.html",
})
export class AutoRedemptionTestStateJsonDialogComponent {
  private i18nService = inject(I18nService);
  private platformUtilsService = inject(PlatformUtilsService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: AutoRedemptionTestStateJsonDialogData) {}

  async copyJson(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.data.json);
      this.platformUtilsService.showToast("success", null, this.i18nService.t("valueCopied"));
    } catch {
      this.platformUtilsService.showToast("error", null, this.i18nService.t("copyTextError"));
    }
  }
}
